import type { TipoOperacao } from '../../api/movimentacoes.js';
import { contagemDoRecorte } from '../../api/paginacao.js';
import type { OpcaoFiltro } from '../../componentes/Filtros.js';

/**
 * Como a trilha se lê: período do recorte, contagem e tipo da operação.
 *
 * Tudo em português e no formato do armazém — a tela do supervisor não mostra
 * ISO 8601 nem o nome do `enum` do banco. O horário sai de
 * `componentes/datas.ts`, que é o formatador de data do painel inteiro.
 */

/** Contagem do recorte, no gênero certo. A regra é a de `api/paginacao.ts`. */
export function contagemDeMovimentacoes(total: number): string {
  return contagemDoRecorte(total, 'movimentação', 'movimentações', 'Nenhuma movimentação');
}

const ROTULO_DO_TIPO: Readonly<Record<TipoOperacao, string>> = {
  Coleta: 'Coleta',
  Movimentacao: 'Movimentação',
  ContagemInventario: 'Contagem de inventário',
};

export function rotuloDoTipo(tipo: TipoOperacao): string {
  return ROTULO_DO_TIPO[tipo];
}

/**
 * Recorte de tempo padrão da listagem.
 *
 * Sete dias, não o histórico inteiro: a consulta precisa responder em até 3s
 * com 5.000 movimentações (RNF-006), e quem abre a tela está atrás do que
 * aconteceu agora. "Todo o período" continua a um clique.
 */
export const PERIODO_PADRAO = '7';

export const PERIODOS: readonly OpcaoFiltro[] = [
  { valor: 'hoje', rotulo: 'Período · hoje' },
  { valor: '7', rotulo: 'Últimos 7 dias' },
  { valor: '30', rotulo: 'Últimos 30 dias' },
  { valor: 'todos', rotulo: 'Todo o período' },
];

const MILISSEGUNDOS_POR_DIA = 24 * 60 * 60 * 1000;

/** Início do período em ISO, ou nada quando o recorte é o histórico inteiro. */
export function inicioDoPeriodo(periodo: string, agora: Date = new Date()): string | undefined {
  if (periodo === 'hoje') {
    // Meia-noite local, não 24 horas atrás: "hoje" é o dia do turno de quem
    // está na tela, e o operador não pensa em janelas móveis.
    return new Date(agora.getFullYear(), agora.getMonth(), agora.getDate()).toISOString();
  }

  const dias = Number(periodo);

  if (!Number.isFinite(dias) || dias <= 0) {
    return undefined;
  }

  return new Date(agora.getTime() - dias * MILISSEGUNDOS_POR_DIA).toISOString();
}
